import Popup from "@templates/Components/Popup/Popup.js";
import Space from "@modules/navigator/Space/Space.js";
import App from "@templates/App/App.js";
import Navigator from "@modules/navigator/Navigator.js";

const PriceListTable = {
    init(el) {
        this.el = $('[view="PriceListTable"].PriceListTable');

        if (!this.el.length) {
            return;
        }

        this.table = this.el.find(".table");
        this.items = this.el.find(".item.available, .item.reserved");
        this.bubble = this.el.find(".bubble");

        this.start();
        this.bind();
    },

    start() {
        this.table.each(function (i, el) {
            PriceListTable.Table.init(el);
        });
    },

    bind() {
        if (!App.isMobile) {
            this.items.off('mouseenter').on('mouseenter', (evt) => this.showBubble(evt, true));
            this.items.off('mouseleave').on('mouseleave', (evt) => this.showBubble(evt, false));
            this.items.off('mousemove').on('mousemove', (evt) => this.moveBubble(evt));
        }
    },

    moveBubble(evt) {
        const offset = 10;
        const bubbleWidth = this.bubble.outerWidth();
        const bubbleHeight = this.bubble.outerHeight();

        // Determine cursor position relative to the document
        const cursorX = evt.pageX;
        const cursorY = evt.pageY;

        // Get window dimensions and scroll position
        const windowWidth = $(window).width();
        const windowHeight = $(window).height();
        const scrollLeft = $(window).scrollLeft();
        const scrollTop = $(window).scrollTop();

        // Calculate new x and y positions
        let x = cursorX - bubbleWidth + offset; // Default to the left of the cursor
        let y = cursorY - bubbleHeight - offset; // Default above the cursor

        // Adjust position if cursor is too close to the right edge
        if (cursorX - scrollLeft + bubbleWidth + offset > windowWidth) {
            x = cursorX - bubbleWidth - offset; // Position to the left of the cursor
        } else {
            x = cursorX + offset; // Position to the right of the cursor
        }

        // Adjust position if cursor is too close to the bottom edge
        if (cursorY - scrollTop + bubbleHeight + offset > windowHeight) {
            y = cursorY - bubbleHeight - offset; // Position above the cursor
        } else {
            y = cursorY + offset; // Position below the cursor
        }

        // Apply fixed position styles
        this.bubble.css({
            top: `${y - scrollTop}px`,
            left: `${x - scrollLeft}px`
        });
    },

    showBubble(evt, state) {
        if (state === true) {
            this.prepareBubble(evt);
        }

        this.bubble.toggleClass("hidden", !state);
    },

    prepareBubble(evt) {
        const image = $(evt.currentTarget).data("image");

        this.bubble.find("img").attr("src", image);
    },

    Table: {
        init(el) {
            this.table = $(el);

            this.row = $(el).find('.row.item');
            this.skeleton = $(el).find(".loading").addClass("hidden");

            this.bind();
            this.afterLoad();
        },

        bind() {
            this.bindSortableTable();

            this.row.click((evt) => {
                const spaceID = $(evt.currentTarget).data("space");
                const space = NAVIGATOR_DATA.flats[spaceID] || null;

                if (space) {
                    Navigator.view = 'pricelist';
                    Space.show(space);
                }

                return false;
            });
        },


        bindSortableTable() {
            let $table = this.table;
            let $headerCells = $table.find('.header .cell').not(".sortIgnore");

            $headerCells.on("click", (evt) => {
                let $clickedCell = $(evt.currentTarget);
                let columnIndex = $clickedCell.index();
                let isAscending = !$clickedCell.hasClass('sorted-asc');

                // Remove sorting classes from all header cells in this table
                $headerCells.removeClass('sorted-asc sorted-desc');

                // Toggle sorting class on the clicked header cell
                $clickedCell.toggleClass('sorted-asc', isAscending);
                $clickedCell.toggleClass('sorted-desc', !isAscending);

                // Sort rows based on the content of the clicked column
                let rows = $table.find('.row').not(".header").get();

                rows.sort((rowA, rowB) => {
                    const parseMixed = (val) => {
                        val = val?.toString().trim() ?? '';
                        const match = val.match(/^(-?\d+(?:\.\d+)?)(.*)$/);
                        if (match) {
                            return {
                                num: parseFloat(match[1]),
                                str: match[2].trim().toLowerCase()
                            };
                        }
                        return { num: null, str: val.toLowerCase() };
                    };

                    const valA = this.getCellValue(rowA, columnIndex);
                    const valB = this.getCellValue(rowB, columnIndex);

                    const a = parseMixed(valA);
                    const b = parseMixed(valB);

                    if (a.num !== null && b.num !== null) {
                        if (a.num !== b.num) {
                            return isAscending ? a.num - b.num : b.num - a.num;
                        } else {
                            return isAscending ? a.str.localeCompare(b.str) : b.str.localeCompare(a.str);
                        }
                    } else {
                        // fallback to full string compare
                        return isAscending ? valA.localeCompare(valB) : valB.localeCompare(valA);
                    }
                });


                // Reorder rows in the table
                $.each(rows, function (index, row) {
                    $table.append(row);
                });
            });
        },

        getCellValue(cell, columnIndex) {
            let element = $(cell).find('.cell').eq(columnIndex);
            let value;

            if (element.find("input").length) {
                value = element.find("input").val();
            } else {
                value = element.text();
            }

            return value.trim();
        },

        showLoading(state) {
            setTimeout(() => {
                //this.skeleton.toggleClass("hidden", !state);
                this.skeleton.addClass("hidden");

            }, 250);
        },

        afterLoad() {
            this.showLoading(false);
        }
    },
}

export default PriceListTable;
